module.exports = __webpack_public_path__ + "static/img/bolang.12a7984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/bolang.png
// module id = TM08
// module chunks = 1